export default "__VITE_ASSET__d1e58a4c__"